module.exports = __webpack_public_path__ + "img/image24.e3c111f7.jpeg";